export const SET_SEARCH_CACHE = "SET_SEARCH_CACHE";
export const CLEAR_SEARCH_CACHE = "CLEAR_SEARCH_CACHE";

export const setSearchCache = payload => ({
  type: SET_SEARCH_CACHE,
  payload
});

export const clearSearchCache = () => ({
  type: CLEAR_SEARCH_CACHE
});
